import React from "react";

export default function MSAccess_StrConv() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_StrConv</h1>
      <p>This is the MSAccess_StrConv component generated from the SQL JSON.</p>
    </div>
  );
}
